export const SET_IS_INIT = 'SET_IS_INIT'
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
export const SET_AUTH_TIME = 'SET_AUTH_TIME'
export const SET_IS_SYNCED = 'SET_IS_SYNCED'
export const SET_SYNC_ERROR = 'SET_SYNC_ERROR'
export const SET_SYNC_TIME = 'SET_SYNC_TIME'

export const SET_POSTS = 'SET_POSTS'
export const SET_POST = 'SET_POST'

export const SET_AUTHORS = 'SET_AUTHORS'
export const SET_AUTHOR = 'SET_AUTHOR'

export const SET_APPCONFIG = 'SET_APPCONFIG'
export const SET_APPFIREWALL = 'SET_APPFIREWALL'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js